import React from 'react';

import { Loader } from '../../components/loader/Loader';

const FrontendAdminToolbar = React.lazy(() =>
  import(
    /* webpackChunkName: "frontend-admin-toolbar" */ './FrontendAdminToolbar.container'
  ),
);

export default (props: any) => (
  <React.Suspense fallback={<Loader />}>
    <FrontendAdminToolbar {...props} />
  </React.Suspense>
);
